import { ReactNode } from 'react'
import { Field, FieldProps } from 'formik'
import { Checkbox as ACheckbox } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { CheckboxWrapper } from './styles'

interface IProps {
  name: string,
  label?: ReactNode
}

const Checkbox = (props: IProps) =>
  <CheckboxWrapper>
    <Field name={props.name}>
      {(fieldprops: FieldProps) => {
        return (
          <ACheckbox
            checked={fieldprops.field.value}
            onChange={change(fieldprops, props.name)}
          >
            {props.label}
          </ACheckbox>
        )
      }}
    </Field>
  </CheckboxWrapper>

const change = (props: FieldProps, name: string) => (event: CheckboxChangeEvent) =>
  props.form.setFieldValue(name, event.target.checked)

export default Checkbox
